import React, { FC, memo } from 'react';
import styled from 'styled-components/native';
import Colors from 'theme/colors';
import Fonts from 'theme/fonts';
import { IoMdArrowBack, IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';

interface Props {
  title?: string;
  onBack?: () => void;
  doneTitle?: string;
  canBack?: boolean;
  showArrow?: boolean;
  disableBack?: boolean;
  disableForward?: boolean;
  onBackDetail?: () => void;
  onForwardDetail?: () => void;
}

const Container = styled.View`
  background-color: ${Colors.MAIN_COLOR};
  min-height: 56px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-horizontal: 12px;
`;

const EmptyView = styled.View`
  width: 40px;
  height: 40px;
`;

const ArrowContainView = styled.View`
  min-width: 72px;
  height: 40px;
  align-items: center;
  justify-content: flex-end;
  flex-direction: row;
`;

const ArrowButton = styled.TouchableOpacity`
  padding: 6px;
  min-width: 36px;
  min-height: 36px;
  align-items: center;
  justify-content: center;
`;

const Button = styled.TouchableOpacity`
  padding: 8px;
  min-width: 40px;
  min-height: 40px;
  align-items: center;
  justify-content: center;
`;

const Title = styled(Fonts.Title1)`
  font-weight: 700;
  color: ${Colors.WHITE};
  flex: 1;
  text-align: center;
  padding-horizontal: 8px;
`;

const HeaderWithBackForward: FC<Props> = ({
  title,
  onBack,
  canBack = false,
  showArrow = false,
  disableBack = false,
  disableForward = false,
  onBackDetail,
  onForwardDetail,
}) => {
  return (
    <Container>
      {canBack ? (
        <Button onPress={onBack} accessibilityLabel="Quay lại">
          <IoMdArrowBack color={Colors.WHITE} size={24} />
        </Button>
      ) : (
        <EmptyView />
      )}
      <Title numberOfLines={1}>{title}</Title>
      {showArrow ? (
        <ArrowContainView>
          <ArrowButton
            onPress={disableBack ? undefined : onBackDetail}
            disabled={disableBack}
            accessibilityLabel="Câu trước"
          >
            <IoIosArrowBack
              color={disableBack ? Colors.MAIN_COLOR_2 : Colors.WHITE}
              size={24}
            />
          </ArrowButton>
          <ArrowButton
            onPress={disableForward ? undefined : onForwardDetail}
            disabled={disableForward}
            accessibilityLabel="Câu sau"
          >
            <IoIosArrowForward
              color={disableForward ? Colors.MAIN_COLOR_2 : Colors.WHITE}
              size={24}
            />
          </ArrowButton>
        </ArrowContainView>
      ) : (
        <EmptyView />
      )}
    </Container>
  );
};

export default memo(HeaderWithBackForward);
